import {
  useQuery,
  UseQueryResult,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "@tanstack/react-query";
import { PostAllTagsList } from "../api";
import { useState } from "react";

type GetSiteListsProps = {
  authToken: string;
  tagName: string;
};

type Tag = {
  tag: string;
  isDefaultTag: boolean;
  occurrence: number;
};

type TagList = {
  status: string;
  msg: Tag[];
};

export const useGetTagsList = ({
  authToken,
  tagName,
}: GetSiteListsProps): UseInfiniteQueryResult<
  TagList,
  Error
> => {
  const [totalCount, setTotalCount] = useState(0);
  let limit = 25;
  return useInfiniteQuery({
    queryKey: ["TagsList", tagName],
    initialPageParam: { skip: 0, limit },
    queryFn: ({
      pageParam,
    }: {
      pageParam: { skip: number; limit: number };
    }) =>
      PostAllTagsList({
        authToken,
        body: {
          tag: pageParam,
          filter: { tagName },
        },
      }).then((res) => {
        setTotalCount(res?.count);
        return res;
      }),
    enabled: !!authToken,
    getNextPageParam: (
      lastPage: TagList,
      allPages: TagList[]
    ) => {
      const totalFetched = allPages.flatMap(
        (page) => page.msg
      ).length;

      // Stop fetching if the total fetched rows reach or exceed the total count
      if (totalFetched >= totalCount) {
        return undefined;
      }

      // Return the skip value for the next page
      return { skip: allPages.length * limit, limit };
    },
  });
};
